import axios from "axios";

export const changePasswordApi = async (data, token) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL_USER}/changePassword`,
      data,
      {
        headers: {
          // "Content-Type" : "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (error.response) {
      throw new Error(error.response?.data?.message);
    }
    if (error.request) {
    }
    throw new Error(error.message);
  }
};
